<template>
    <section class="section_news containerg">
        <div class="title_news">{{ $t('news') }}</div>
        <div class="boxuri_news">
            <router-link :to="{ name: 'news', params: { id: articol.id }}" v-for="articol in articole" :key="articol.id" class="news_box" >

                <div  v-for="imagine in articol.image" :key="imagine.thumbnailpath" class="img_news">
                    <img :src="imagine.thumbnailpath" />
                </div>
                <div class="desc_news">
                    <div class="title_box_news">{{ articol.title }}</div>
                    <div class="date_news"><i class="ri-time-fill"></i>{{ articol.created_at | formatDate }}</div>
                </div>

            </router-link>
            
        </div>

    
    </section>
</template>


<script>
  import moment from 'moment'
  import axios from 'axios';
    import Vue from 'vue';
    import VueFilterDateFormat from 'vue-filter-date-format';

    Vue.use(VueFilterDateFormat);
  
  export default {
      data() {
      return {
        articole : []
      }
    },
    mounted () {
      axios
        .get('https://xpanel.tikibistro.ro/api/news?t='+Number(new Date()),{
            withCredentials: false,
        })
        .then(response => {
            this.articole = response.data.data;
            console.log(response);
        })

        
    },
    filters: {
        formatDate: function(date) {
            return moment.unix(date).lang("ro").format('DD MMMM YYYY')
        }
    }
   
  }
</script>
